"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let idSuffix = 0;
/**
 * This id should be safe to use as a class name. So don't use any special
 * characters that CSS might get confused by.
 */
exports.generateRandomId = () => Math.random()
    .toString(36)
    .slice(2) +
    '_' +
    ++idSuffix;
function clamp(value, bounds) {
    if (bounds) {
        const [min, max] = bounds;
        if (min !== undefined && value < min) {
            return min;
        }
        if (max !== undefined && value > max) {
            return max;
        }
    }
    return value;
}
exports.clamp = clamp;
function clampCenterOfLength(centerValue, length, bounds) {
    if (bounds) {
        const [min, max] = bounds;
        if (min !== undefined && max !== undefined && centerValue - length / 2 < min && centerValue + length / 2 > max) {
            // Return center of space
            return min + (max - min) / 2;
        }
        if (min !== undefined && centerValue - length / 2 < min) {
            return min + length / 2;
        }
        if (max !== undefined && centerValue + length / 2 > max) {
            return max - length / 2;
        }
    }
    return centerValue;
}
exports.clampCenterOfLength = clampCenterOfLength;
function rectContainsPoint(clientRect, x, y) {
    return clientRect.left < x && clientRect.right > x && clientRect.top < y && clientRect.bottom > y;
}
exports.rectContainsPoint = rectContainsPoint;
function transitionNumber(start, end, percent) {
    return start + (end - start) * percent;
}
exports.transitionNumber = transitionNumber;
function* walkElementHierarchyUp(leafElement) {
    let e = leafElement;
    while (e) {
        yield e;
        e = e.parentElement;
    }
}
exports.walkElementHierarchyUp = walkElementHierarchyUp;
exports.browserIsAndroid = navigator.userAgent.match(/Android/);
exports.browserIsSafari = navigator.vendor.match(/Apple/);
exports.browserIsSafariDesktop = exports.browserIsSafari && typeof Touch === 'undefined';
function isMouseEvent(e) {
    return e.touches === undefined;
}
exports.isMouseEvent = isMouseEvent;
//# sourceMappingURL=utils.js.map